import { RAuditConfig } from '@counsel-project/counsel-audit-backend-api'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

type AuditConfigPreviewProps = {
  auditConfig: RAuditConfig
  onClick: (auditConfig: RAuditConfig) => void
}

const AuditConfigPreview = ({ auditConfig, onClick }: AuditConfigPreviewProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, cursor: 'pointer', ':hover': { backgroundColor: 'grey.100' } }}
      onClick={() => onClick(auditConfig)}
      data-qa-id={`config-preview-item-${auditConfig._id}`}
    >
      <Grid container spacing={2}>
        <Grid item>
          <Typography variant="h6">{auditConfig.title}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default AuditConfigPreview
